// 设备类型
export const typeOptions = [
  { key: 1, title: "灭火器" },
  { key: 2, title: "消火栓" },
]

// 养护状态
export const statusOptions = [
  { key: 1, title: "正常" },
  { key: 2, title: "异常" },
]